import axios from "axios";

export const transliterateHindi = async (text) => {
  if (!text) return "";

  try {
    const url = "https://inputtools.google.com/request";

    const res = await axios.get(url, {
      params: {
        text,
        itc: "hi-t-i0-und",
        num: 5,
      },
    });

    if (
      res.data &&
      res.data[0] === "SUCCESS" &&
      res.data[1] &&
      res.data[1][0] &&
      res.data[1][0][1]
    ) {
      return res.data[1][0][1][0];
    }

    return "";
  } catch (err) {
    console.error(err);
    return "";
  }
};